// extracted by mini-css-extract-plugin
export default {"container":"M5C6"};